import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {getCookieConsent, saveCookieConsent, COOKIE_SETTINGS_EVENT} from '../../cookieConsent';
import config from '../../config';
import {localePath} from '../../languages';

const Gdpr = () => {
    const {t, i18n} = useTranslation();
    const [show, setShow] = useState(false);
    const dialogRef = useRef(null);

    useEffect(() => {
        setShow(!getCookieConsent());
        const open = () => setShow(true);
        window.addEventListener(COOKIE_SETTINGS_EVENT, open);
        return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, open);
    }, []);

    useEffect(() => {
        if (!show) return;
        const previousFocus = document.activeElement;
        const overflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        let frame = requestAnimationFrame(() => {
            frame = requestAnimationFrame(() => dialogRef.current?.focus({preventScroll: true}));
        });
        return () => {
            cancelAnimationFrame(frame);
            document.body.style.overflow = overflow;
            previousFocus?.focus({preventScroll: true});
        };
    }, [show]);

    const choose = allowed => {
        saveCookieConsent({analytics: allowed, marketing: allowed});
        setShow(false);
    };

    const trapFocus = event => {
        if (event.key !== 'Tab') return;
        const items = [...dialogRef.current.querySelectorAll('a, button')];
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialogRef.current)) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    };

    if (!show) return null;

    return (
        <div className="cookie-overlay">
            <section className="cookie-dialog" role="dialog" aria-modal="true" aria-labelledby="cookie-title" aria-describedby="cookie-description" tabIndex={-1} ref={dialogRef} onKeyDown={trapFocus}>
                <h2 id="cookie-title">{t('cookie.title')}</h2>
                <p id="cookie-description">{t('cookie.description')} <a href={localePath(config.cookiePolicyUrl, i18n.language)} target="_blank" rel="noreferrer">{t('footer.cookiePolicy')}</a></p>
                <div className="cookie-actions">
                    <button type="button" className="cookie-choice" onClick={() => choose(false)}>{t('cookie.no')}</button>
                    <button type="button" className="cookie-choice" onClick={() => choose(true)}>{t('cookie.yes')}</button>
                </div>
            </section>
        </div>
    );
};

export default Gdpr;
